import {
  Button,
  Dialog,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import React from 'react';
import { useFormik } from 'formik';
import { useGetAllUsersQuery, useUpdateUserMutation } from 'state/api';

const UpdateUser = ({ data }) => {
  const [open, setOpen] = React.useState(false);
  const { data: userData } = useGetAllUsersQuery();

  const formik = useFormik({
    initialValues: {
      email: data.email,
      contact: data.contact,
      name: data.name,
      role: data.role,
      newPassword: '',
      confirmPassword: '',
    },
    validate: (values) => {
      const errors = {};
      if (!values.email) {
        errors.email = 'Required';
      }
      if (values.newPassword !== values.confirmPassword) {
        errors.confirmPassword = 'Passwords do not match';
      }
      return errors;
    },
    onSubmit: (values) => {
      // submit the form using rtk query mutation and close the dialog
      updateUser({
        email: values.email,
        password: values.newPassword,
        contact: values.contact,
        name: values.name,
        role: values.role,
        reportTo: values?.reportTo
      })
        .unwrap()
        .then((res) => {
          alert('User Updated successfully');
        })
        .catch((err) => {
          alert('Error in updating user');
        });
      // above code can be replaced with a toast notification

      //   reset the form fields
      formik.resetForm();
      setOpen(false);
    },
  });
  const [updateUser] = useUpdateUserMutation();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Change Password</DialogTitle>
        <form onSubmit={formik.handleSubmit}>
          <div className='flex flex-col gap-4 p-4'>
            <TextField
              disabled
              fullWidth
              id='email'
              name='email'
              label='Email'
              value={formik.values.email}
              // onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
            <TextField
              fullWidth
              id='name'
              name='name'
              label='Name'
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />

            <TextField
              fullWidth
              id='contact'
              name='contact'
              label='Contact'
              value={formik.values.contact}
              onChange={formik.handleChange}
              error={formik.touched.contact && Boolean(formik.errors.contact)}
              helperText={formik.touched.contact && formik.errors.contact}
            />

            {/* Role Select Menu */}

            <FormControl fullWidth>
              <InputLabel id='role'>Role</InputLabel>
              <Select
                label='role'
                labelId='role'
                id='role'
                name='role'
                value={formik.values.role}
                onChange={formik.handleChange}
                required
                size='medium'
              >
                <MenuItem value={'RTO Agent'}>RTO Agent</MenuItem>
                <MenuItem value={'Sales Consultant'}>Sales Consultant</MenuItem>
                <MenuItem value={'Sales Manager'}>Sales Manager</MenuItem>
                <MenuItem value={'Insurance Agent'}>Insurance Agent</MenuItem>
                <MenuItem value={'Workshop Staff'}>Workshop Staff</MenuItem>
                <MenuItem value={'Accountant'}>Accountant</MenuItem>
              </Select>
            </FormControl>

            <div className='mt-4'>
              <div className='dropdown text-center'>
                <FormControl fullWidth>
                  <InputLabel id='role'>Reports to</InputLabel>
                  <Select
                    label='reportTo'
                    labelId='reportTo'
                    id='reportTo'
                    name='reportTo'
                    value={formik.values.reportTo}
                    onChange={formik.handleChange}
                    required
                    size='medium'
                  >
                    {userData?.result?.map(
                      (d) =>
                        (d.role === 'Sales Manager' || d.role === 'Admin') && (
                          <MenuItem key={d._id} value={d._id}>
                            {d.name}
                          </MenuItem>
                        )
                    )}
                  </Select>
                </FormControl>
                {/* error message */}
                {formik.errors.role && formik.touched.role && (
                  <p className='text-red-500 text-xs italic'>
                    {formik.errors.role}
                  </p>
                )}
              </div>
            </div>

            <TextField
              fullWidth
              id='newPassword'
              name='newPassword'
              label='New Password'
              type='password'
              value={formik.values.newPassword}
              onChange={formik.handleChange}
              error={
                formik.touched.newPassword && Boolean(formik.errors.newPassword)
              }
              helperText={
                formik.touched.newPassword && formik.errors.newPassword
              }
            />
            <TextField
              fullWidth
              id='confirmPassword'
              name='confirmPassword'
              label='Confirm Password'
              type='password'
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              error={
                formik.touched.confirmPassword &&
                Boolean(formik.errors.confirmPassword)
              }
              helperText={
                formik.touched.confirmPassword && formik.errors.confirmPassword
              }
            />
            <Button
              variant='contained'
              size='large'
              className='bg-slate-600 text-gray-50 hover:bg-slate-700'
              type='submit'
            >
              Update
            </Button>
          </div>
        </form>
      </Dialog>
      <Button
        variant='contained'
        size='small'
        className='bg-slate-600 text-gray-50 hover:bg-slate-700'
        onClick={handleClickOpen}
      >
        Update
      </Button>
    </div>
  );
};

export default UpdateUser;
